import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/context/auth-context';
import { DASHBOARD_ROUTES } from '@worktracker/shared';

export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-teal border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to={DASHBOARD_ROUTES.LOGIN} replace />;
  }

  return <Outlet />;
}
